export default class Page {
  pageTexture = null;
  stage = null;
  page = null;
  texture = null;
  hoverTexture = null;
  animate = null;

  constructor(animate, textures, stage, page) {
    this.texture = textures.texture;
    this.hoverTexture = textures.hoverTexture;
    this.pageTexture = new PIXI.Sprite(textures.texture);
    this.stage = stage;
    this.page = page;
    this.animate = animate;

    this.createPage();
  }

  createPage = () => {
    const {stage, page, texture, pageTexture, hoverTexture} = this;
    const rotation = page.rotation * Math.PI / 180;

    pageTexture.interactive = true;
    pageTexture.position.set(page.x, page.y);
    pageTexture.pivot.set(page.width / 2, page.height / 2);
    pageTexture.rotation = rotation;
    pageTexture.on('mouseover', () => this.setTexture(hoverTexture));
    pageTexture.on('mouseout', () => this.setTexture(texture));
    stage.addChild(pageTexture);
  };

  setTexture = (texture) => {
    this.pageTexture.texture = texture;
    this.animate();
  }
}



// WEBPACK FOOTER //
// ./src/views/SheetCalculator/Pixi/Page.js